import { forwardRef, InputHTMLAttributes } from 'react';

interface FormCheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
  error?: string | undefined;
}

export const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            ref={ref}
            type="checkbox"
            className={`w-4 h-4 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary ${className}`}
            {...props}
          />
          <span className="text-sm font-medium text-text">{label}</span>
        </label>
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      </div>
    );
  },
);

FormCheckbox.displayName = 'FormCheckbox';
